import { makeStyles, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
    rowHeader: {
        position: 'relative',
        boxSizing: 'border-box',
        border: 'none',

        '& div[data-resizable-table-header-resize-handle]': {
            opacity: 0,
            pointerEvents: 'none',
            transition: `opacity ${tokens.durationNormal}`,
        },

        '& div[data-resizable-table-header-resize-handle-active="true"]': {
            opacity: 1,
            pointerEvents: 'all',
        },

        '&:hover div[data-resizable-table-header-resize-handle]': {
            opacity: 1,
            pointerEvents: 'all',
        },
    },
});
